module.exports = __webpack_public_path__ + "static/img/16.928c3b9b.png";